export default {
  loading(state) {
    return state.loading;
  },
  groups(state) {
    return state.groups;
  },
  currentGroup(state) {
    return state.currentGroup;
  },
  groupsMap(state) {
    return state.groupsMap;
  },
  isRootGroup(state) {
    return state.groups.parentId === null;
  },
};
